import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,HttpResponse, HttpHeaders,} from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { filter, switchMap, tap, take, catchError, finalize } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { secureStorage } from '../services/encryption/secureservice';
import { CookieService } from '../services/cookie.service';
import { environment } from '../../../environments/environment';
import { RootService } from '../services/root.service';
import { Store } from '@ngxs/store';
import { setShow, setToken } from '../../fni-modules/core/store/app.action';

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
  options: any;
  isLoggedIn: boolean = false;
  freeaccessToken: any
  freerefreshToken: any;
  private FreeTokenInProgress = false;
  private FreeTokenSubject: Subject<any> = new BehaviorSubject<any>(null);
  private FreeRefreshTokenInProgress = false;
  private FreeRefreshTokenSubject: Subject<any> = new BehaviorSubject<any>(null);
  private rq: any = false;
  private translaterq: any = false;
  private searchUnbxd: any = false;
  private leadReqId :any = false;
  private OptyReq: any = false;
  protected server = environment.apiUrl + 'api/v1/cv_online/';
  totalRequests = 0;
  completedRequests = 0;
  appToken: any;
  private store: Store;

  constructor(
    public router: Router,
    public rootService: RootService,
    private ssrcookieService: CookieService,
    private localStorage: secureStorage,
    @Inject(PLATFORM_ID) private platformId: Object,
    // private store: Store
  ) {
    // this.store.subscribe(({ appStore }) => {
    //   this.appToken = appStore.accessToken;
    // });
  }



  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.toString().includes('api.tatamotors/fni-service') || request.url.toString().includes('api/login') || request.url.toString().includes(environment.FNIBaseURL+'challenge-token/verify') ||
      (
        // Comment below line for run directly using application overview url. || Uncomment for using through OSP to F&I redirection.
        !request.url.toString().includes(environment.FNIBaseURL+'challenge-token') && !request.url.toString().includes(environment.FNIBaseURL+'schemes/genericOffers') &&
        request.url.toString().includes(environment.FNIBaseURL))) {
      this.store.dispatch(new setShow(true));
      // this.totalRequests++;
      request = this.AddRequestHeaders(request);
      return next.handle(request).pipe(
        finalize(() => {
          // this.completedRequests++;
          this.store.dispatch(new setShow(false));
        })
      );
    } else {
    const accessExpired: any = this.ssrcookieService.getItem('access_token') ? this.ssrcookieService.getItem('access_token') : null;
    const refreshExpired: any = this.ssrcookieService.getItem('refresh_token') ? this.ssrcookieService.getItem('refresh_token') : this.localStorage.getItem('ref_token');

    if ( !accessExpired || !refreshExpired ) {
      this.ssrcookieService.removeItem('access_token');
      this.ssrcookieService.removeItem('refresh_token');
      return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
    }

    if (accessExpired && refreshExpired) {
      return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
    }
    if (!accessExpired && !refreshExpired) {
      if (!this.FreeTokenInProgress) {
        this.FreeTokenInProgress = true;
        this.FreeTokenSubject.next(null);
      } else {
        this.isLoggedIn = this.rootService.isLoggedIn() ? true : false;
        if (this.isLoggedIn) {
          if (!this.FreeRefreshTokenInProgress) {
            this.FreeRefreshTokenInProgress = true;
            this.FreeRefreshTokenSubject.next(null);
            if (!accessExpired) {

              if (
                this.localStorage.getItem('FreeRefreshTokenInProgress') != 'true'
              ) {
                this.localStorage.setItem('FreeRefreshTokenInProgress', 'true');
                let res: any = this.rootService.refreshToken2();
                return res?.pipe(
                  switchMap((authResponse: any) => {
                    if (authResponse) {
                      this.FreeRefreshTokenInProgress = false;
                    }
                    this.FreeRefreshTokenSubject.next(
                      authResponse.data.refresh_token
                    );

                    return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
                  })
                );
              }
            } else {
            }
          } else {
            if (!accessExpired) {
              if (
                this.localStorage.getItem('FreeRefreshTokenInProgress') != 'true'
              ) {
                this.localStorage.setItem('FreeRefreshTokenInProgress', 'true');
                this.rootService.refreshToken2();
              }
            }
          }
        } else {
          if (isPlatformBrowser(this.platformId)) {
            window.location.reload();
          }
        }
      }
    }
    if (!accessExpired && refreshExpired) {
      if (!this.FreeRefreshTokenInProgress) {
        this.FreeRefreshTokenInProgress = true;
        this.FreeRefreshTokenSubject.next(null);
        if (!accessExpired) {
          if (this.localStorage.getItem('FreeRefreshTokenInProgress') != 'true') {
            this.localStorage.setItem('FreeRefreshTokenInProgress', 'true');
            let res: any = this.rootService.refreshToken2();
            return res?.pipe(switchMap((authResponse: any) => {
              if (authResponse) {
                this.FreeRefreshTokenInProgress = false;
              }
              this.FreeRefreshTokenSubject.next(authResponse.data.refresh_token);
              return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
            })
            );
          }
        } else {
        }
      } else {
        return this.FreeRefreshTokenSubject.pipe(
          filter((result) => result !== null),
          take(1),
          switchMap(() => {
            return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
          })
        );
      }
    }
     // return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));

    }
  }
  injectToken(request: HttpRequest<any>) {
    const token = this.ssrcookieService.getItem("access_token");
    // return this.executeAPI(request, next, access_token);
    this.rq = request?.url.includes("https://eguruskindev.api.tatamotors/api");
    this.translaterq = request?.url.includes("https://revapi.reverieinc.com/");
    this.searchUnbxd = request?.url.includes("https://search.unbxd.io/022d9e0d04f448a445126a43bfbaaf6e/ss-unbxd-prod-tatamotors49921702360514/");
    this.leadReqId = request?.url.includes("payment_detail");
    // this.fniOfferrq = request.url.includes("https://fni-dev.api.tatamotors/fni-service/");
    // this.OptyReq = request.url.includes("api/cv/chatbot/search");

    if (this.translaterq) {
      return request.clone({
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          // Authorization: `Bearer ${access_token}`,
          'REV-API-KEY': environment.anuvadakTransliterate.avc,
          'REV-APP-ID': environment.anuvadakTransliterate.appId,
          'REV-APPNAME': 'transliteration',
          src_lang: 'hi',
          tgt_lang: 'en',
        }),
      });
    }
   else if (this.searchUnbxd) {
      return request.clone({
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
      });
    }
    else if(this.leadReqId && (JSON.parse(this.localStorage.getItem('accessTokenSILead')))){

      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${JSON.parse(this.localStorage.getItem('accessTokenSILead'))}`,
        },
      });
    }
    // else if(this.fniOfferrq){
    //   changedReq = requestAPI.clone({
    //     headers: new HttpHeaders({
    //       "Content-Type": "application/json",
    //       Authorization: `4$223232@6676`,
    //     }),
    //   });
    // }
    // else if (this.OptyReq) {
    //   return request.clone({
    //     headers: new HttpHeaders({
    //       'Content-Type': 'application/json',
    //       HTTP_AUTHORIZATION: 'Bearer FXG0TGaOG7URoE5uEatawgl0ZzTnFG',
    //     }),
    //   });
    // }
     else {
    //   return request.clone({
    //     headers: new HttpHeaders({
    //       'Content-Type': 'application/json',
    //       Authorization: `Bearer ${token}`,
    //     }),
    //   });
    // }
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        // "Access-Control-Allow-Origin":"*",
        // 'Access-Control-Allow-Headers' : 'x-requested-with,content-type',
        // 'Access-Control-Request-Headers': 'x-requested-with'
      },
    });
  }
  }
  handleError(error: HttpErrorResponse) {
    let data: any = {};
    let errorMsg = 'Something went wrong, Please try again !';
    data = {
      msg: error && error.error && error.error.data ? error.error.data.msg : error && error.error && error.error == '<h1>403 Forbidden</h1>' ? errorMsg : error,
      status: error.status,
      apierror: error,
      // netWorkStatus: window.navigator.onLine
      netWorkStatus: true
    };
    // if( data.msg == 'Authentication credentials were expired.'){
    //     this.sharedService.logout();
    // }
    //         // this.errorDialogService.openDialog(data);
    if (error.status === 401) {
      // if (isPlatformBrowser(this.platformId)) {

      //         this.localStorage.clear();
      //         throw data;
    }
    //         }
    if (error.status === 0 || error.status === 500 || error.status === 503) {
      data.msg = 'Something went wrong, Please try again !'
      return throwError(data);
    }
    if (!data.netWorkStatus) {
      data.msg = "You are Offline.Please check the network connectivity";
      return throwError(data);
    }
    return throwError(data);
  }
  executeAPI(
    requestAPI: HttpRequest<any>,
    next: HttpHandler,
    access_token: any
  ) {

    let changedReq: any;
    if (this.translaterq) {
      changedReq = requestAPI.clone({
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          // Authorization: `Bearer ${access_token}`,
          'REV-API-KEY': environment.anuvadakTransliterate.avc,
          'REV-APP-ID': environment.anuvadakTransliterate.appId,
          'REV-APPNAME': 'transliteration',
          src_lang: 'hi',
          tgt_lang: 'en',
        }),
      });
    }
    else if (this.searchUnbxd) {
      changedReq = requestAPI.clone({
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
      });
    }
    // else if(this.fniOfferrq){
    //   changedReq = requestAPI.clone({
    //     headers: new HttpHeaders({
    //       "Content-Type": "application/json",
    //       Authorization: `4$223232@6676`,
    //     }),
    //   });
    // }

    else if(this.leadReqId && (JSON.parse(this.localStorage.getItem('accessTokenSILead')))){

      return requestAPI.clone({
        setHeaders: {
          Authorization: `Bearer ${JSON.parse(this.localStorage.getItem('accessTokenSILead'))}`,
        },
      });
    }
    else if (this.OptyReq) {
      changedReq = requestAPI.clone({
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          HTTP_AUTHORIZATION: 'Bearer FXG0TGaOG7URoE5uEatawgl0ZzTnFG',
        }),
      });
    } else {
      changedReq = requestAPI.clone({
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${access_token}`,
        }),
      });
    }
    return next.handle(access_token ? changedReq : requestAPI).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (!event.body && !this.rq) {
              throw new HttpErrorResponse({
                error: event.body.msg
                  ? event.body.msg
                  : event.body.data.msg
                    ? event.body.data.msg
                    : '',
                headers: event.headers,
                status: 403,
                statusText: 'Warning',
                url: event.url ? event?.url : '',
              });
            }
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            // this.errorHandler.handleError(err);
          }
        }
      )
    );
  }

  private AddRequestHeaders(request: HttpRequest<any>): HttpRequest<any> {
    this.appToken = this.appToken && request.url.toString().includes(environment.FNIBaseURL+'challenge-token/verify') ? this.appToken : this.ssrcookieService.getItem('accessToken');
    if (!this.appToken && this.appToken.length === 0) {
      if (isPlatformBrowser(this.platformId)) {
        let token = this.ssrcookieService.getItem('accessToken') ? this.ssrcookieService.getItem('accessToken') : '';
        this.store.dispatch(new setToken(token));
      }
    }
    let headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    if (this.appToken && this.appToken.length > 0 && !request.url.toString().includes('api.tatamotors/fni-service') &&
      !request.url.toString().includes(environment.FNIBaseURL+'challenge-token/verify')) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.appToken}`,
        },
        headers: headers.headers,
      });
    } else {
      return request.clone({
        headers: headers.headers,
      });
    }
  }

}
